import { RowData } from "../../request-tc/tc-tabs/tc-standard-weight-info";

export interface ITcCertifiedRawMaterialInformation {
  tcCertifiedRawMaterialCode: string;
  tcCertifiedRawMaterialWeight: any;
  tcGeographicWeightInfo: any;
}

// tcCertifiedRawMaterialCountryOrArea: any;
// tcCertifiedRawMaterialCountryOrAreaDescription: any;
// tcCertifiedRawMaterialStateOrProvince: any;
// tcCertifiedRawMaterialStateOrProvinceDescription: any;

export interface ITcStandardCertifiedWeightInformation {
  tcStandard: string;
  tcCertifiedWeight: number;
  tcCertifiedRawMaterialInformation: ITcCertifiedRawMaterialInformation[];
}

export interface ITcDetails {
  tcStandardCertifiedWeightInformation: ITcStandardCertifiedWeightInformation[];
}

export interface ITcCertifiedWeightInfo {
  tcId: string;
  tcDetails: ITcDetails;
}

interface RawMaterialInformation {
  tcCertifiedRawMaterialCode: string;
  tcCertifiedRawMaterialWeight: any;
  tcCertifiedRawMaterialCountryOrArea: string[];
  tcCertifiedRawMaterialCountryOrAreaDescription: string[];
  tcCertifiedRawMaterialStateOrProvinceDescription: string[];
  tcCertifiedRawMaterialStateOrProvince: string[];
}

interface StandardCertifiedWeightInformation {
  tcStandard: string;
  tcCertifiedWeight: number;
  tcCertifiedRawMaterialInformation: RawMaterialInformation[];
}

interface TCDetails {
  tcStandardCertifiedWeightInformation: StandardCertifiedWeightInformation[];
}

interface InputData {
  tcId: string;
  tcDetails: TCDetails;
}

// export function transformToRowData(data: InputData): RowData[] {
//   if (!data || !data.tcDetails || !Array.isArray(data.tcDetails.tcStandardCertifiedWeightInformation)) {
//       throw new Error("Invalid input format");
//   }

//   return data.tcDetails.tcStandardCertifiedWeightInformation.flatMap((info: any) => {
//       const tcStandard = info.tcStandard || "";

//       return info.tcCertifiedRawMaterialInformation.map((rawMaterial: any) => ({
//           tcStandard: tcStandard,
//           rawMaterialWeight: parseFloat(rawMaterial.tcCertifiedRawMaterialWeight).toFixed(2).toString(),
//           rawMaterialCode: rawMaterial.tcCertifiedRawMaterialCode,
//           rawMaterialCodeDesc: rawMaterial.tcCertifiedRawMaterialCode,
//           tcCertifiedRawMaterialCountryOrArea: rawMaterial.tcCertifiedRawMaterialCountryOrArea,
//           tcCertifiedRawMaterialCountryOrAreaDescription: rawMaterial.tcCertifiedRawMaterialCountryOrAreaDescription ? rawMaterial.tcCertifiedRawMaterialCountryOrAreaDescription : '', 
//           tcCertifiedRawMaterialStateOrProvinceDescription: rawMaterial.tcCertifiedRawMaterialStateOrProvinceDescription ? rawMaterial.tcCertifiedRawMaterialStateOrProvinceDescription : '',
//           tcCertifiedRawMaterialStateOrProvince: rawMaterial.tcCertifiedRawMaterialStateOrProvince,
//       }));
//   });
// }

const tcStandardDetails =
  [
    { label: "Organic Content Standard (OCS)", value: "Organic Content Standard (OCS)", code: "OCS" }, // Represents "Valid"
    { label: "Global Recycled Standard (GRS)", value: "Global Recycled Standard (GRS)", code: "GRS" }, // Represents "Expired"
    { label: "Recycled Claim Standard (RCS)", value: "Recycled Claim Standard (RCS)", code: "RCS" }, // Represents "Suspended"
    { label: "Responsible Down Standard (RDS)", value: "Responsible Down Standard (RDS)", code: "RDS" }, // Represents "Withdrawn"
    { label: "Responsible Wool Standard (RWS)", value: "Responsible Wool Standard (RWS)", code: "RWS" }, // Represents "Withdrawn"
    { label: "Responsible Mohair Standard (RMS)", value: "Responsible Mohair Standard (RMS)", code: "RMS" }, // Represents "Withdrawn"
    { label: "Responsible Alpaca Standard (RAS)", value: "Responsible Alpaca Standard (RAS)", code: "RAS" }, // Represents "Withdrawn"
    { label: "Content Claim Standard (CCS)", value: "Content Claim Standard (CCS)", code: "CCS" }, // Represents "Withdrawn"
    { label: "Sustainable Fiber Alliance (SFA)", value: "Sustainable Fiber Alliance (SFA)", code: "SFA" }, // Represents "Withdrawn"
    { label: "Global Organic Textile Standard (GOTS)", value: "Global Organic Textile Standard (GOTS)", code: "GOTS" }, // Represents "Withdrawn"
  ];

export function transformToRowData(data: any, validated_data: any): any {
  const result: any[] = [];
  const matchedValidatedItems: Set<string> = new Set();

  // Handle case where main data is empty
  if (Array.isArray(data?.tcDetails?.tcStandardCertifiedWeightInformation) && data.tcDetails.tcStandardCertifiedWeightInformation.length === 0) {
    return validated_data?.map((item: any) => ({
      tcStandard: tcStandardDetails.find((std: any) => std.label === item.tcStandard)?.code || '',
      tcStandardDescription: item.tcStandard,
      tcStandardLabelGrade: item.tcStandardLabelGrade,
      tcCertifiedWeight: item.tcProductCertifiedWeightSum || 0,
      tcCertifiedRawMaterialCode: item.tcProductRawMaterialCodeStandardLabel,
      tcCertifiedRawMaterialCodeDescription: item.tcCertifiedRawMaterialCodeDescription || '',
      tcCertifiedRawMaterialWeight: 0,
      tcGeographicWeightInfo: []
    })) || [];
  }

  // Process input `data`
  for (const info of data?.tcDetails?.tcStandardCertifiedWeightInformation || []) {
    // Normalize standard to code - handle both "GRS" and "Global Recycled Standard (GRS)" formats
    const standardFromAPI = info.tcStandard;
    const standard = tcStandardDetails.find((std: any) =>
      std.code === standardFromAPI || std.label === standardFromAPI || std.value === standardFromAPI
    )?.code || standardFromAPI;

    const labelGrade = info.tcStandardLabelGrade;
    const certifiedWeight = info.tcCertifiedWeight;

    for (const rawMaterial of info.tcCertifiedRawMaterialInformation || []) {
      const {
        tcCertifiedRawMaterialCode,
        tcCertifiedRawMaterialCodeDescription,
        tcCertifiedRawMaterialWeight,
        tcCertifiedRawMaterialCountryOrArea,
        tcCertifiedRawMaterialCountryOrAreaDescription,
        tcCertifiedRawMaterialStateOrProvince,
        tcCertifiedRawMaterialStateOrProvinceDescription
      } = rawMaterial;

      const matchingValidatedItem = validated_data?.find((item: any) => {
        const stdCode = tcStandardDetails.find((std: any) => std.label === item.tcStandard)?.code || item.tcStandard;
        return (
          stdCode === standard &&
          item.tcProductRawMaterialCodeStandardLabel === tcCertifiedRawMaterialCode
        );
      });

      if (!matchingValidatedItem) continue;

      const uniqueKey = `${standard}|${tcCertifiedRawMaterialCode}`;
      matchedValidatedItems.add(uniqueKey);

      const existing = result.find(item =>
        item.tcStandard === standard &&
        item.tcCertifiedRawMaterialCode === tcCertifiedRawMaterialCode
      );

      const geoInfo = {
        tcGeographicWeight: tcCertifiedRawMaterialWeight || 0,
        tcCertifiedRawMaterialCountryOrArea: tcCertifiedRawMaterialCountryOrArea || [],
        tcCertifiedRawMaterialCountryOrAreaDescription: tcCertifiedRawMaterialCountryOrAreaDescription || [],
        tcCertifiedRawMaterialStateOrProvince: tcCertifiedRawMaterialStateOrProvince || [],
        tcCertifiedRawMaterialStateOrProvinceDescription: tcCertifiedRawMaterialStateOrProvinceDescription || []
      };

      if (existing) {
        existing.tcGeographicWeightInfo.push(geoInfo);
      } else {
        result.push({
          tcStandard: standard,
          tcStandardLabelGrade: labelGrade,
          tcCertifiedWeight: certifiedWeight,
          tcCertifiedRawMaterialCode,
          tcCertifiedRawMaterialCodeDescription,
          tcCertifiedRawMaterialWeight,
          tcGeographicWeightInfo: [geoInfo]
        });
      }
    }
  }

  // Add unmatched validated_data entries
  validated_data?.forEach((item: any) => {
    const stdCode = tcStandardDetails.find((std: any) => std.label === item.tcStandard)?.code || item.tcStandard;
    const key = `${stdCode}|${item.tcProductRawMaterialCodeStandardLabel}`;
    if (!matchedValidatedItems.has(key)) {
      result.push({
        tcStandard: stdCode,
        tcStandardDescription: item.tcStandard,
        tcStandardLabelGrade: item.tcStandardLabelGrade,
        tcCertifiedWeight: item.tcProductCertifiedWeightSum || 0,
        tcCertifiedRawMaterialCode: item.tcProductRawMaterialCodeStandardLabel,
        tcCertifiedRawMaterialCodeDescription: item.tcCertifiedRawMaterialCodeDescription || '',
        tcCertifiedRawMaterialWeight: 0,
        tcGeographicWeightInfo: []
      });
    } else {
      const existing = result.find(r => r.tcStandard === stdCode && r.tcCertifiedRawMaterialCode === item.tcProductRawMaterialCodeStandardLabel);
      if (existing) {
        existing.tcCertifiedWeight = item.tcProductCertifiedWeightSum || 0;
      }
    }
  });

  return result;
}


export function reverseTransformToInputData(inputArray: any, tcId: any) {

  const output = {
    tcId,
    tcDetails: {
      tcStandardCertifiedWeightInformation: [] as ITcStandardCertifiedWeightInformation[]
    }
  };

  for (const item of inputArray) {
    const standardInfo: any = {
      tcStandard: item.tcStandard,
      tcStandardLabelGrade: item.tcStandardLabelGrade || '',
      tcCertifiedWeight: item.tcCertifiedWeight,
      tcCertifiedRawMaterialInformation: []
    };

    const rmCode = item.tcCertifiedRawMaterialCode;
    const rmDesc = item.rawMaterialCodeDesc;

    if (!item.tcGeographicWeightInfo || item.tcGeographicWeightInfo.length === 0) {
      standardInfo.tcCertifiedRawMaterialInformation.push({
        tcCertifiedRawMaterialCode: rmCode,
        tcCertifiedRawMaterialCodeDescription: rmDesc,
        tcCertifiedRawMaterialWeight: 0
      });
      output.tcDetails.tcStandardCertifiedWeightInformation.push(standardInfo);
    } else {
      for (const rawMaterial of item.tcGeographicWeightInfo) {

        const rawMaterialInfo: any = {
          tcCertifiedRawMaterialCode: rmCode,
          tcCertifiedRawMaterialCodeDescription: rmDesc,
          tcCertifiedRawMaterialWeight: rawMaterial.tcGeographicWeight || 0,
          tcCertifiedRawMaterialCountryOrArea: rawMaterial.tcCertifiedRawMaterialCountryOrArea || [],
          tcCertifiedRawMaterialCountryOrAreaDescription: rawMaterial.tcCertifiedRawMaterialCountryOrAreaDescription || [],
          tcCertifiedRawMaterialStateOrProvince: rawMaterial.tcCertifiedRawMaterialStateOrProvince || [],
          tcCertifiedRawMaterialStateOrProvinceDescription: rawMaterial.tcCertifiedRawMaterialStateOrProvinceDescription || []
        };

        standardInfo.tcCertifiedRawMaterialInformation.push(rawMaterialInfo);
      }
      output.tcDetails.tcStandardCertifiedWeightInformation.push(standardInfo);
    }

  }

  return output;
}
